import Vue from 'vue'
import store from '@/store'

Vue.prototype.showLoading = function() {
  store.commit('setLoading', true);
}
Vue.prototype.hideLoading = function() {
  store.commit('setLoading', false);
}